import { REGION_ORDER } from "../lib/events";
import { Link } from "../lib/router";
import { useApp } from "../lib/store";
import { Wordmark } from "./bits";

export function Nav() {
  const { status, admin, availableRegions, region, setRegion } = useApp();

  const parsing = status?.matches.filter(m => m.status === "watching").length ?? 0;
  const queued = status?.queued ?? 0;

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-bg/85 backdrop-blur-md">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-4 px-6">
        <Link to="/" className="press flex items-center">
          <Wordmark />
        </Link>

        <div className="flex items-center gap-3">
          {admin && (parsing > 0 || queued > 0) && (
            <span className="hidden items-center gap-1.5 rounded-full bg-accent/10 px-2.5 py-1 font-mono text-[11px] text-accent sm:flex">
              <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-accent" />
              {parsing > 0 ? `tailing ${parsing}` : `${queued} queued`}
            </span>
          )}
          <RegionSwitch
            regions={availableRegions.length > 0 ? availableRegions : REGION_ORDER}
            active={region}
            onPick={setRegion}
          />
        </div>
      </div>
    </header>
  );
}

/** The one region control in the app. A single persisted value drives every
 *  page, so opening a window never silently snaps you back to another region. */
function RegionSwitch({
  regions,
  active,
  onPick,
}: {
  regions: string[];
  active: string;
  onPick: (r: string) => void;
}) {
  return (
    <div className="flex items-center gap-0.5 rounded-lg bg-raised/70 p-0.5 font-mono text-[12px]">
      {regions.map(r => {
        const on = r === active;
        return (
          <button
            key={r}
            onClick={() => onPick(r)}
            aria-pressed={on}
            className={`press rounded-md px-2.5 py-1 font-medium uppercase tracking-wider ${
              on
                ? "bg-accent/15 text-accent"
                : "text-faint hover:text-dim"
            }`}
          >
            {r}
          </button>
        );
      })}
    </div>
  );
}
